/// <reference path="DOMAttached.js" />

class RegisterHelp extends DOMAttached {
	constructor(el) {
		super(el);

		for (var curLi = this.el.querySelector("li"); curLi != undefined; curLi = curLi.next("li")) {
			var inp = curLi.querySelector("input");
			if (inp == undefined) {
				inp = curLi.querySelector("select");
			}
			var tooltip = curLi.querySelector(".registerHelpTooltip");
			if (inp != undefined && tooltip != undefined) {
				this.safeObserve(inp, 'focus', this.onFocusBlur.bind(this));
				this.safeObserve(inp, 'blur', this.onFocusBlur.bind(this));
			}
		}
	}

	onFocusBlur() {
		var data = $A(arguments);
		data.shift();
		if (data[0] == undefined) {
			return;
		}
		if (data[0].classList.contains('registerHelpTooltipShown')) {
			data[0].classList.remove('registerHelpTooltipShown');
		} else {
			data[0].classList.add('registerHelpTooltipShown');
		}
	}
}
